package org.braunequip.web.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.braunequip.web.components.layouts.PageLayout
import org.braunequip.web.components.widgets.RentalCard
import org.braunequip.web.components.widgets.RentalCardContainer
import org.braunequip.web.styles.*
import org.braunequip.web.util.Constants
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Text

@Page
@Composable
fun EquipmentServicesPage() {
    val sitePalette = ColorMode.current.toSitePalette() //Not needed yet, need to set values in SiteTheme.kt

    PageLayout("Equipment Services") {
        //Hero Section
        Section(PageHeroContainer.toModifier().then(equipmentHeroBg.toModifier()).toAttrs()) {
            Row(PageHeroSectionRow.toModifier(), horizontalArrangement = Arrangement.Start) {
                Div(PageHeroHeadlineStyle.toModifier().toAttrs()) {
                    SpanText("Equipment Services")
                }
            }
        }

        Section(SectionContainer.toModifier()
            .backgroundColor(Colors.WhiteSmoke).toAttrs()
        ) {
            Row(SectionTitleRow.toModifier()
                .classNames("container", "is-widescreen"),
                horizontalArrangement = Arrangement.Center
            ) {
                Div(HeadlineTextStyle.toModifier().color(Colors.Black).toAttrs()) {
                    SpanText("Equipment Rentals and Contracting")
                }
            }

            Row(SectionSubtitleRow.toModifier()
                .classNames("container", "is-widescreen"),
                horizontalArrangement = Arrangement.Center
            ) {
                P(Modifier.margin(0.px).color(Colors.Black).fontFamily(Constants.FONT_FAMILY2).toAttrs()) {
                    Text("Ability to Rent a Variety of Equipment or Supply with an Operator!")
                }
            }

            Div(RentalCardContainer.toModifier()
                .classNames("container", "is-widescreen")
                .toAttrs()) {
                RentalCard("trailerrentals.jpg", "Trailer Rentals", "DOT Compliant Flatbeds and Low Boy. 48' and 45'. Short and Long term rentals available.")
                RentalCard("heavyequip.jpg", "Cat D6N XL", "2016 Caterpillar D6N XL, Enclosed cab, Ice cold A/C. GPS ready")
                RentalCard("taylorforklift.jpg", "36k Taylor Forklift", "Taylor 36k Forklift. 48\" load center. Side Shift and Fork Positioners. 8' forks")
                RentalCard("cat316el.jpg", "Cat 316EL", "Caterpillar 316El Excavator, 36\" Bucket Hydraulic Thumb. Back Up Camera. A/C")
                RentalCard("KomatsuD61PX.jpg", "Komatsu D61PX Dozer", "Komatsu D61PX Dozer, 6 Way Blade /Fire Ready. Back Up Camera. A/C")
                RentalCard("3600GallonWaterTruckcropped.jpg", "3600 Gallon Water Truck", "Primer Pump for Drafting, Front Rear and Side Sprayers. Hose Reel")
                RentalCard("pilotcar.jpg", "Pilot Cars", "Expertise in permitting, Multi Pilot Car abilities")
                RentalCard("BottomEndDumpcropped.jpg", "Bottom and End Dump", "Fleet of Bottom and End Dump Trailers")
                RentalCard("ChipLogTrailers.jpg", "Chip and Log Trailers", "Fleet of Possum Belly Chip Trailers and Log capabilities")
            }
        }
    }
}